<template>
  <section class="c-px-1 relative overflow-hidden">
    <!-- Middle line -->
    <Wave
      path="line"
      alignment="top"
      color="text-primary"
      class="hidden c-lg:block"
      additional-class="c-mt-8 opacity-20"
      svg-class="c-mt-9"
    />
    <div class="container c-py-5 c-md:c-py-6 c-lg:c-pb-0">
      <div class="row c-justify-center">
        <div class="c-lg:col-6">
          <header class="c-mb-5 c-lg:c-mb-6">
            <h2 class="c-mb-2 c-lg:c-mb-5 text-center">
              {{ t('favorite_products') }}
            </h2>
          </header>
        </div>
        <!-- Bottom small bubble -->
        <div class="col-1 c-p-0 absolute bottom-0 right-0 c-mb-8 mr-n7 hidden c-xxl:block embed-responsive embed-responsive-1by1 bg-light opacity-40 pattern-2 c-mb-8" />
        <!-- Bottom small left bubble -->
        <div class="col-2 c-p-0 absolute  bottom-0 left-0 c-mb-8 ml-n9 c-pr-5 hidden c-lg:block embed-responsive embed-responsive-1by1 bg-light opacity-40 pattern-2" />
        <!-- Middle bubble -->
        <div class="col-3 c-pl-8 c-pr-0 absolute left-40 top-0 c-mt-9 c-ml-6 hidden c-lg:block embed-responsive embed-responsive-1by1 bg-light opacity-40 pattern-2 c-mt-6" />
        <!-- Carousel -->
        <Carousel
          v-if="crossSell?.length > 0"
          :slides="crossSell"
          class="col-12"
        />
        <BaseLoading
          v-else
          :style="{ minHeight: '670px' }"
        />
      </div>
    </div>
    <!-- bottom gap because of footer waves -->
    <div class="c-py-2 c-md:c-py-3 c-lg:c-py-8" />
  </section>
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

import BaseLoading from '@/components/general/BaseLoading.vue'
import Wave from '@/components/general/BaseWave.vue'
import Carousel from '@/components/carousel/Carousel.vue'
import { useProductStore } from '@/stores/ProductStore'

const { t } = useI18n()

const productStore = useProductStore()

const crossSell = ref()

const loadCrossSell = async () => {
  crossSell.value = await productStore.loadCrossSell('quantity=6&kind=homepage_favorite_cross_sell')
}

loadCrossSell()
</script>

<i18n>
  {
    "cs": {
    "favorite_products": "Nejoblíbenější Mixit"
},
    "sk": {
    "favorite_products": "Najobľúbenejší Mixit"
},
    "pl": {
    "favorite_products": "Najpopularniejsze produkty Mixit"
},
    "hu": {
    "favorite_products": "Legnépszerűbb"
},
    "de": {
    "favorite_products": "Unsere beliebtesten Leckereien"
},
    "at": {
    "favorite_products": "Unsere beliebtesten Leckereien"
},
    "ro": {
    "favorite_products": "Cele mai populare gustări ale noastre"
},
    "fr": {
    "favorite_products": "Mixit le plus populaire"
},
    "it": {
    "favorite_products": "I Mixit più popolari"
}
  }
</i18n>
